import { createMemoryHistory, createRouter } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import { useUserStore } from '@/stores/user';
import MeView from '../views/MeView.vue';
import LoginView from '../views/LoginView.vue';
import ResetPin from '../views/ResetPin.vue';
import { datadogRum } from '@datadog/browser-rum';

function employeeIdToNumber(route: { params: { id: string } }) {
  return {
    employeeId: Number(route.params.id),
  };
}

export const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/login/:id',
    name: 'login',
    component: LoginView,
    props: employeeIdToNumber,
  },
  {
    path: '/reset-pin/:id',
    name: 'reset-pin',
    component: ResetPin,
    props: employeeIdToNumber,
  },
  {
    path: '/me',
    name: 'me',
    component: MeView,
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createMemoryHistory(),
  routes,
});

router.beforeEach((to, _from, next) => {
  const user = useUserStore();
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!user.isAuthenticated()) {
      next({ name: 'home' });
      return;
    }
  }
  next();

  datadogRum.startView(to.name?.toString());
});

export default router;
